module.exports = __webpack_public_path__ + "static/media/carouselTwo.6fede021.png";